// extracted by mini-css-extract-plugin
module.exports = {"seeLiveProject7":"Sculptures-module--seeLiveProject7--wC-NN","sourceCodeProject7":"Sculptures-module--sourceCodeProject7--2mOpI"};